import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=b5e1ca54&scoped=true&"
import script from "./Star.vue?vue&type=script&lang=ts&"
export * from "./Star.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e1ca54",
  null
  
)

export default component.exports